export default {
  main: {
    hero: `
        当社のゲームでは、<br/>
        <strong>魅力的な</strong>キャラクターたち<br/>
        と<strong>心躍る</strong>世界を楽しめます\`
      `,
    homescapes: `執事のオースティンとともに、美しいお屋敷を修復していくScapes™シリーズの大作`,
    township: `イベント、大会、PVPトーナメントが満載の楽しい街づくりゲーム`,
  },
  common: {
    login: 'ログイン',
    logout: 'ログアウト',
    support: 'サポート',
    privacy: 'プライバシーポリシー',
    terms: `利用規約`,
    and: 'と',
    guest: 'ゲスト',
    play: 'プレイ',
    install: 'インストール',
  },
  support: {
    title: `サポートが必要ですか？`,
    description: `本ゲームを利用するうえで何かお困りの点がありましたら、
      お気軽にお問い合わせください`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'ホームスケイプ',
    caption: '執事のオースティンが家族の住むお屋敷に温かさと快適さを取り戻すのを手伝いましょう。',
    description: `執事のオースティンが家族の住むお屋敷に
      温かさと快適さを取り戻すのを手伝いましょう。一歩足を踏み入れた瞬間から
      冒険が始まります！`,
    xsolla: 'Xsollaはホームスケイプ公認のグローバルディストリビューターです',
    install: {
      title: '@:common.install',
      text: `ホームスケイプがデスクトップに登場！
      Web版をインストールして、わずか数クリックでオースティンに会いに行きましょう！`,
      button: '@:common.install',
    },
  },
  township: {
    title: 'タウンシップ',
    caption: `夢の街作り！作物を収穫して施設で加工して、
      商品を売って街を発展させよう`,
    description: `夢の街作り！作物を収穫して施設で加工して、
      商品を売って街を発展させよう`,
    xsolla: 'Xsollaはタウンシップ公認のグローバルディストリビューターです',
    install: {
      title: '@:common.install',
      text: `デスクトップでタウンシップをプレイ！
      ゲームのウェブ版をインストールして、数クリックで街を訪れましょう！`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: '当サイトでは、サービスを向上するためにCookieを利用しています',
    link: `詳細`,
    button: '許可',
  },
  game: {
    notSupported: `モバイルデバイスはサポート対象外です。コンピューターからログインしてプレイしてください。`,
  },
};
